module.exports = __webpack_public_path__ + "img/chanping2.e7f18f7c.png";